export default "__VITE_ASSET__DoEI3U7M__"